import {
  AfterViewInit,
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  HostBinding, Inject,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DOCUMENT } from '@angular/common';


export const DIALOG_PANEL_CLASS = 'dialog-layout__panel';

@Component({
  selector: 'app-dialog-layout',
  templateUrl: './dialog-layout.component.html',
  styleUrls: ['./dialog-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class DialogLayoutComponent implements AfterViewInit {
  @ViewChild('closeButton') closeButton;
  @ViewChild('actions') actions;
  @HostBinding('class.dialog-layout') dialogLayoutClass = true;

  protected enableExternalIcon = true;
  protected disableActions = true;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private dialogRef: MatDialogRef<any>,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
  }

  ngAfterViewInit(): void {
    const enableExternalIcon = this.closeButton?.children?.length > 2;
    const disableActions = !this.actions?.nativeElement?.children.length;
    this.dialogRef?.addPanelClass(DIALOG_PANEL_CLASS);
    this.dialogRef?.addPanelClass('madar--v2');
    Promise.resolve().then(() => {
      this.enableExternalIcon = enableExternalIcon;
      this.disableActions = disableActions;
      this.changeDetectorRef.markForCheck();
    });
  }
}
